(function() {
    var map = document.getElementById('us-map');
    if (!map) return;

    var mapLinks = Array.prototype.slice.call(map.querySelectorAll('a.state'));
    if (!mapLinks.length) return;

    var currentPath = window.location.pathname.replace(/\/+$/, '') + '/';
    var activeLink = null;
    var labelLayer = null;
    var ns = 'http://www.w3.org/2000/svg';

    function getPathFromLink(link) {
        var rawHref = link.getAttribute('href') || link.getAttribute('xlink:href');
        if (!rawHref || rawHref.indexOf('#') === 0) return '';
        try {
            var parsed = new URL(rawHref, window.location.origin);
            return parsed.pathname.replace(/\/+$/, '') + '/';
        } catch (e) {
            return '';
        }
    }

    function getLabelLayer() {
        if (labelLayer && labelLayer.parentNode === map) return labelLayer;
        labelLayer = map.querySelector('#hover-label-layer');
        if (!labelLayer) {
            labelLayer = document.createElementNS(ns, 'g');
            labelLayer.setAttribute('id', 'hover-label-layer');
            labelLayer.setAttribute('pointer-events', 'none');
            map.appendChild(labelLayer);
        }
        return labelLayer;
    }

    function getStateGroup(link) {
        return link.querySelector('g.state-group') || link.querySelector('g');
    }

    function restoreLabel(link) {
        if (!link) return;
        var group = getStateGroup(link);
        var text = labelLayer && labelLayer.querySelector('text.text');
        if (text && group) {
            text.classList.remove('is-visible');
            group.appendChild(text);
        }
        link.classList.remove('is-hovered');
    }

    function showLabel(link) {
        if (activeLink === link) return;

        restoreLabel(activeLink);
        activeLink = link;
        link.classList.add('is-hovered');

        var text = link.querySelector('text.text');
        var layer = getLabelLayer();
        // Keep label layer last so text paints above all states
        if (map.lastElementChild !== layer) {
            map.appendChild(layer);
        }
        if (text) {
            text.classList.add('is-visible');
            layer.appendChild(text);
        }
    }

    function hideLabel(link) {
        if (activeLink !== link) return;
        restoreLabel(link);
        activeLink = null;
    }

    mapLinks.forEach(function(link) {
        var linkPath = getPathFromLink(link);
        if (linkPath && linkPath === currentPath) {
            link.classList.add('is-active');
            link.setAttribute('aria-current', 'page');
        }

        link.addEventListener('mouseenter', function() {
            showLabel(link);
        });
        link.addEventListener('mouseleave', function(e) {
            if (e.relatedTarget && link.contains(e.relatedTarget)) return;
            hideLabel(link);
        });
        link.addEventListener('focus', function() {
            showLabel(link);
        });
        link.addEventListener('blur', function() {
            hideLabel(link);
        });
    });

    // Clear stuck hover if the pointer leaves the map entirely
    map.addEventListener('mouseleave', function(e) {
        if (e.relatedTarget && map.contains(e.relatedTarget)) return;
        if (activeLink) {
            restoreLabel(activeLink);
            activeLink = null;
        }
    });
})();
